import { GalleryVerticalEnd } from 'lucide-react';
import { useState } from 'react';

import { cn } from '@shared/components/ui/cn';
import type { Workspace } from '@shared/hooks/use-workspaces';

export function WorkspaceIcon({
  workspace,
  className,
}: {
  workspace: Workspace | null;
  className?: string;
}) {
  const [broken, setBroken] = useState<string[]>([]);
  const src =
    [workspace?.iconUrl, workspace?.logoUrl].find((url) => url && !broken.includes(url)) ?? null;

  return (
    <div
      className={cn(
        'flex size-8 shrink-0 items-center justify-center overflow-hidden rounded-lg border bg-sidebar-background',
        className,
      )}
    >
      {src ? (
        <img
          src={src}
          alt=""
          className="size-full object-contain"
          onError={() => {
            setBroken((urls) => [...urls, src]);
          }}
        />
      ) : (
        <GalleryVerticalEnd className="size-4" />
      )}
    </div>
  );
}
